<ng-request-detail-header
  *ngIf="(store$ | async) as store"
  [waybillOwner]="customerNumber"
  [waybillOwnerSequence]="customerSequence"
  [waybillType]="customerType"
  [status]="waybillDetail?.status"
  [requestNumber]="requestNumber"
  [carId]="waybillDetail?.cars"
  (useAsTemplate)="navigateToTemplate()"
  (print)="printPreview()"
></ng-request-detail-header>
<div #printContainer>
  <ng-request-detail
    *ngIf="(store$ | async) as store"
    [form]="form"
    [waybillType]="customerType"
    [stored]="waybillDetail?.stored"
    [updated]="waybillDetail?.updated"
    [userId]="waybillDetail?.userId"
    [userName]="waybillDetail?.userName"
    [status]="waybillDetail?.status"
    [waybillDetail]="store.waybillDetail"
    [requestSummary]="store.requestSummary"
    [rejectSummary]="store.rejectSummary"
    [waybillSerial]="waybillSerial"
    [requestNumber]="requestNumber"
    (cancelDiversion)="submitCancel()"
    (rejectDiversion)="submitReject()"
    (completeDiversion)="submitComplete()"
    [loading]="store.isLoadingWaybillDetail"
  ></ng-request-detail>
</div>
